/**
 * Anima o preenchimento da barra de frete grátis ao atualizar o carrinho.
 */
(function () {
  let previousProgress = null;

  function getTargetProgress(container) {
    const bar = container.querySelector('.jv-cart-free-shipping__bar');
    const fill = container.querySelector('.jv-cart-free-shipping__fill');
    if (!bar || !fill) return null;

    const fromBar = parseFloat(bar.getAttribute('aria-valuenow'));
    if (!Number.isNaN(fromBar)) return Math.min(100, Math.max(0, fromBar));

    const fromData = parseFloat(fill.dataset.progress);
    if (!Number.isNaN(fromData)) return Math.min(100, Math.max(0, fromData));

    return 0;
  }

  function animateBar(container) {
    const fill = container.querySelector('.jv-cart-free-shipping__fill');
    if (!fill) return;

    const target = getTargetProgress(container);
    if (target === null) return;

    const start = previousProgress !== null ? previousProgress : 0;

    fill.style.transition = 'none';
    fill.style.width = start + '%';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.transition = '';
        fill.style.width = target + '%';
        previousProgress = target;
      });
    });
  }

  function initFreeShippingBars(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-jv-free-shipping-bar]').forEach(animateBar);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFreeShippingBars();
  });

  document.addEventListener('cart:updated', function () {
    initFreeShippingBars();
  });
})();
